<script setup lang="ts">
import {AppTypography} from "~/components";

const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  hideDetails = undefined,
  label = '',
  placeholder = '',
  rounded = 'lg',
  bgColor = 'white',
  prefix = '',
  suffix = '',
  suffixText = '',
  prefixIcon = '',
  suffixIcon = '',
  required = false,
  type = 'text',
  controlVariant = 'hidden'
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  hideDetails?: boolean | 'auto';
  label?: string;
  rounded?: string | number | boolean;
  placeholder?: string;
  bgColor?: string;
  prefix?: string;
  suffix?: string;
  suffixText?: string;
  prefixIcon?: string;
  suffixIcon?: string;
  required?: boolean;
  type?: string;
  controlVariant?: string;
}>();

const text = defineModel<number | null>();
</script>
<template>
  <v-number-input
      v-model="text"
      variant="solo"
      :type="type"
      :hide-details="hideDetails"
      :error-messages="errorMessages"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :rounded="rounded"
      :bg-color="bgColor"
      :prefix="prefix"
      :suffix="suffix"
      data-testid="text-field"
      control-variant="hidden"
  >
    <template #label>
      {{ label }}<span v-if="required" class="text-error"> *</span>
    </template>
    <template #prepend-inner>
      <slot name="prepend-inner">
        <v-icon v-if="prefixIcon" :icon="prefixIcon"/>
      </slot>
    </template>
    <template #append-inner>
      <slot name="append-inner">
        <AppTypography
            element="p"
            type="subheadline-2"
            v-if="suffixText"
            class="d-flex justify-end"
            style="width: 70px; color: #80808E"
        >
          {{ suffixText }}
        </AppTypography>
        <v-icon v-if="suffixIcon" :icon="suffixIcon"/>
      </slot>
    </template>
  </v-number-input>
</template>

<style scoped>
:deep(.v-input__control) {
  overflow: visible;
}

:deep(.v-field) {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  box-shadow: none !important;
  overflow: visible;
}

:deep(.v-field--focused) {
  border-color: #414156 !important;
  background-color: #FFFCE9 !important;
}

:deep(.v-field--error) {
  border-color: rgb(var(--v-theme-error)) !important;
}

:deep(.v-field--error .v-field__outline),
:deep(.v-field__outline) {
  display: none;
}

:deep(.v-field__overlay) {
  display: none;
}

:deep(.v-text-field__prefix__text ) {
  font-family: 'Big Shoulders', sans-serif;
  color: #01011D;
  font-weight: 700;
}

:deep(.v-field__input) {
  font-family: 'Big Shoulders', sans-serif;
  color: #01011D;
  font-weight: 700;
}

:deep(.v-text-field__suffix__text) {
  color: #80808E;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
}
</style>
